export const CURR_VERSION_INFO = {
    version: "release2.2-coinbase-extension",
    reset: true
}